
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-wand",classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"secondary",attrs:{"d":"M3.573 17.027L13.3 7.3l4.4 4.4-9.727 9.727a1.8 1.8 0 01-2.546 0l-1.854-1.854a1.8 1.8 0 010-2.546z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M20.893 8.391l-2.434 2.562-4.384-4.328 2.455-2.579a1.752 1.752 0 012.516-.034l1.812 1.804c.704.701.72 1.855.035 2.575zM14.465 4.294l-1.486-.522-1.299.856.069-1.491-1.267-.898 1.528-.4.516-1.411.876 1.244 1.585.026-.986 1.169.464 1.427zM19.999 17.673l-.923-1.128-1.439.052.772-1.146-.569-1.319 1.4.419 1.087-.867.093 1.405 1.241.783-1.342.449-.32 1.352z"}})])
          )
        }
      }
    